type ClassificationObject = {
  [key: string]: {
    badgeText: string
    label: string
    description: string
    color: string
  }
}
export const ATTENDANCE_CLASSIFICATIONS_OBJECT: ClassificationObject = {
  0: {
    badgeText: 'Desconhecido',
    label: 'Sem classificação',
    description: 'Não existe classificação',
    color: 'gray',
  },
  1: {
    badgeText: 'Cinta',
    label: 'Sem classificação',
    description: 'Não sabe informar ou não há necessidade da classificação',
    color: 'gray',
  },
  2: {
    badgeText: 'Azul',
    label: 'Não Urgente',
    description: 'Sem risco imediato de agravo à saúde',
    color: 'blue',
  },
  3: {
    badgeText: 'Verde',
    label: 'Pouco urgente',
    description: 'Baixo risco imediato de agravo à saúde',
    color: 'green',
  },
  4: {
    badgeText: 'Amarelo',
    label: 'Urgente',
    description: 'Condição que pode se agravar sem atendimento',
    color: 'yellow',
  },
  5: {
    badgeText: 'Laranja',
    label: 'Muito Urgente',
    description: 'Risco imediato da perda de função de órgãos ou membros',
    color: 'orange',
  },
  6: {
    badgeText: 'Vermelho',
    label: 'Emergência',
    description: 'Risco imediato de perder a vida',
    color: 'red',
  },
}
